import BorderLinearProgress from 'components-v2/mocules/BorderLinearProgress';
import { useEffect, useState } from 'react';
import styles from '../styles.module.css';

const ProgressTour = ({ handleCallBack, stepActive, tourStep, width = 310 }) => {
  const [progress, setProgress] = useState(30);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          handleCallBack();
          return 0;
        }
        return oldProgress + 1;
      });
    }, 300);
    return () => {
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    setProgress(0);
  }, [stepActive]);
  if (tourStep.length === 1) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.linerProgress}>
        <BorderLinearProgress variant="determinate" value={progress} width={width} height={8} bgcolor="#D9D9D9" bgliner="#fff" linerradius={0} radius={0} />
      </div>
    </div>
  );
};

export default ProgressTour;
